<template>
  <div class="content">
    <div class="c_position">
        <span class="el-icon-location-outline"></span>
        <label>你现在的位置：</label>
        <label>
          <span @click="routerNav(1)">首页</span>
          <span
            :style="$route.query.pos1=='内容详情'? '':cclick"
            @click="routerNav($route.query.pos1)"
          >>{{$route.query.pos1}}</span>
          <span
            :style="$route.query.pos1=='内容详情'? '':cclick"
            @click="routerNav($route.query.pos3)"
          >>{{$route.query.pos3}}</span>
          <span v-if="$route.query.pos2">>{{$route.query.pos2}}</span>
        </label>
    </div>
    <div class="details">
        <div class="d_type" @click="openUrl(list.webAddress)">{{list.title}}</div>
        <div class="d_time">[ <span style="font-size:15px;margin-right:15px;">信息来源：{{list.sourceNews == null? '惠州市电力行业协会':list.sourceNews}}</span>{{list.createTime|dataFormat}} ]</div>
        <div class="text" v-html="list.body" style="white-space: pre-wrap;"></div>
        <div class="down" v-for="(item,index) in list.fileList" v-if="item && item.fileType == 4" :key="index">
          <div v-if="item.fileType == 4">
            <span >下载附件 : </span><span @click="allowgetattach(item.filePath,item.fileName)">{{item.fileName}}</span>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { Quill, quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  data() {
    return {
      pos1: "t",
      pos2: "s",
      list: [],
      cclick: `cursor:pointer;`,
      bodyP:''
    };
  },
  methods: {
    openUrl(url){
      if (url == null) {
        
      }else{
        window.location.href = url
      }
    },
    routerNav(val) {
      if (val == 1) {
        this.$router.push({ path: "/home" });
      }
      if (val == "行协概况") {
        this.$router.push({ path: "/IndustryProfile" });
      }

      if (val == "行协动态") {
        this.$router.push({ path: "/Industrytrends" });
      }else if (val == "行协新闻") {
        this.$router.push({ path: "/Industrytrends" ,query:{num:0}});
        // ptext(2)
      }else if (val == "行协公告") {
        this.$router.push({ path: "/Industrytrends" ,query:{num:1}});
        // ptext(2)
      }else if (val == "行协通知") {
        this.$router.push({ path: "/Industrytrends" ,query:{num:2}});
        // ptext(2)
      }

      if (val == "会员中心") {
        this.$router.push({ path: "/MemberCenter" });
      }else if (val == "会员单位") {
        this.$router.push({ path: "/MemberCenter" ,query:{num:3}});
        // ptext(2)
      }else if (val == "文学天地") {
        this.$router.push({ path: "/MemberCenter" ,query:{num:0}});
        // ptext(2)
      }else if (val == "会员动态") {
        this.$router.push({ path: "/MemberCenter" ,query:{num:1}});
        // ptext(2)
      }

      if (val == "行业信息" || val == "政策法规") {
        this.$router.push({ path: "/IndustryInformation" ,query:{num:0}});
      }else if (val == "行业新闻") {
        this.$router.push({ path: "/IndustryInformation" ,query:{num:1}});
        // ptext(2)
      }else if (val == "行业探讨") {
        this.$router.push({ path: "/IndustryInformation" ,query:{num:2}});
        // ptext(2)
      }

      if (val == "下载中心") {
        this.$router.push({ path: "/DownloadCenter" });
      }
      if (val == "人才招聘") {
        this.$router.push({ path: "/TalentRecruitment" });
      }
      if (val == "搜索") {
        this.$router.push({ path: "/Search" });
      }
    },
    jump() {},
    // 获取后缀名方法
    getExtension (name) {
      return name.substring(name.lastIndexOf(".")+1)
    },
    // 下载附件
    allowgetattach(filePath,fileName){
      this.$axios({
        url: `/tourist/download/${filePath}?isRename=true`,
        method: "get",
        responseType:'blob'
      }).then(res => {
        var blob = new Blob()
        
        if (this.getExtension(filePath) === 'pdf') {
          blob = new Blob([res.data], {
            type: `application/pdf` // word文档为msword,pdf文档为pdf
          })
        } else if(this.getExtension(filePath) === 'docx'){
          blob = new Blob([res.data], {
            type: `application/msword` // word文档为msword,pdf文档为pdf
          })
        }else if(this.getExtension(filePath) === 'xlsx'){
          blob = new Blob([res.data], {
            type: `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet` // word文档为msword,pdf文档为pdf
          })
        }else if(this.getExtension(filePath) === 'xls') {
          blob = new Blob([res.data], {
            type: `application/vnd.ms-excel` // word文档为msword,pdf文档为pdf
          })
        }else if(this.getExtension(filePath) === 'zip') {
          blob = new Blob([res.data], {
            type: `application/zip` // word文档为msword,pdf文档为pdf
          })
        }else if(this.getExtension(filePath) === 'txt') {
          blob = new Blob([res.data], {
            type: `text/plain` // word文档为msword,pdf文档为pdf
          })
        }else if(this.getExtension(filePath) === 'zip') {
          blob = new Blob([res.data], {
            type: `application/zip` // word文档为msword,pdf文档为pdf
          })
        }else {
           blob = new Blob([res.data])
        }

        if ('download' in document.createElement('a')) {
          var downloadElement = document.createElement('a')
          var href = window.URL.createObjectURL(blob) // 创建下载的链接
          downloadElement.href = href

          downloadElement.download = fileName
          document.body.appendChild(downloadElement)
          downloadElement.click() // 点击下载
          document.body.removeChild(downloadElement) // 下载完成移除元素
          window.URL.revokeObjectURL(href) // 释放掉blob对象
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
    }
  },
  mounted() {
    // console.log(this.$route.query.data);
    this.$axios({
      method: "GET",
      url: "/tourist/getArticalMsg",
      params: {
        id: this.$route.query.data
      }
    }).then(res => {
      // console.log(res.data.data.body);
      // console.log(res.data.data.body.slice(0,2) + ' style="text-align:center"' + res.data.data.body.slice(2));
      this.list = res.data.data;
      // this.bodyP = res.data.data.body.slice(0,2) + ' style="text-align:center"' + res.data.data.body.slice(2)
      window.scrollBy(0, -1000);
    });
  },
  filters:{
      dataFormat(msg) {
        try {
            var rs = msg.slice(0, 10);
            return rs;
        } catch (TypeError) {
          
        }
    }
  }
};
</script>

<style lang='less' scoped>
.c_position {
  margin-left: 50%;
  transform: translate(-200%);
}
.details {
  width: 1213px;
  min-height: 1000px;
  // margin: 0 20%;
  margin-left: 50%;
  transform: translate(-50%);
  margin-top: 23px;
  padding-bottom: 50px;
  // margin-left: 355px;
  overflow: auto;
  border: 1px solid rgba(225, 225, 225, 1);
  display: flex;
  flex-direction: column;
  .d_type {
    text-align: center;
    margin: 0 auto;
    // width: 800px;
    width: 100%;
    // height: 42px;
    color: rgba(16, 16, 16, 1);
    font-size: 28px;
    font-family: SourceHanSansSC-bold;
    font-weight: 900;
    margin-top: 47px;
  }
  .d_time {
    margin: 0px auto;
    width: 1083px;
    height: 34px;
    border-bottom: 1px solid rgba(230, 230, 230, 1);
    text-align: center;
    color: rgba(144, 147, 153, 1);
    font-size: 16px;
  }
  .text {
    width: 995px;
    margin-top: 38px;
    margin-left: 109px;
    color: rgba(16, 16, 16, 1);
    font-size: 16px;
    line-height: 30px;
    /deep/ p:not(p<img) {
      text-align: center;
    }
  }
  .down {
    margin:30px 0 0 109px;
    span:nth-child(1){
      color:red
    }
    span:nth-child(2){
      &:hover {
        cursor: pointer;
        text-decoration: underline;
        color:#e1a33d;
      }
    }
  }
  
}
</style>